import React, { forwardRef } from 'react';

const STROKE = {
  thin: 1.15,
  light: 1.35,
  regular: 1.7,
  bold: 2.1,
};

const CrossedSwords = forwardRef(function CrossedSwords(
  { size = 18, weight = 'light', color = 'currentColor', ...props },
  ref
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={STROKE[weight] || STROKE.light}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      <path d="M14.5 17.5 3 6V3h3l11.5 11.5" />
      <path d="m13 19 6-6" />
      <path d="m16 16 4 4" />
      <path d="m19 21 2-2" />
      <path d="M9.5 6.5 21 18v3h-3L6.5 9.5" />
      <path d="m11 5-6 6" />
      <path d="M8 8 4 4" />
      <path d="m5 3-2 2" />
    </svg>
  );
});

export default CrossedSwords;
